module.exports = __webpack_public_path__ + "AvertaStd-RegularItalic.svg?c34ff7533c672086c225fe2947d0ca76";